import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";

const base = (campusId: number) => `/admin/campus/${campusId}/scheduleBalances`;

const rango = (desde: string, hasta: string, fresco = false) => {
	const params: any = {};
	if (fresco) { params.fresco = 1; }
	if (desde) { params.desde = desde; }
	if (hasta) { params.hasta = hasta; }
	return { params };
};

/** Saldos por Horario: cobrado, vencido y por cobrar de cada horario, y sus alumnos. */
export class ScheduleBalancesService {
	/** El servidor guarda el resumen 10 minutos; fresco = recalcularlo ya (botón Actualizar). */
	summary = async (campusId: number, desde: string, hasta: string, fresco = false): Promise<AxiosResponse<any>> =>
		axiosInstance.get<any>(base(campusId), rango(desde, hasta, fresco));

	students = async (campusId: number, scheduleId: number, desde: string, hasta: string): Promise<AxiosResponse<any>> =>
		axiosInstance.get<any>(`${base(campusId)}/${scheduleId}`, rango(desde, hasta));
}
